// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3H5et","content":"Consent_content__2mR6G","footer":"Consent_footer__L9Lg7"};